"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _reactToString = _interopRequireDefault(require("react-to-string"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _FormField = _interopRequireDefault(require("../FormField/_FormField"));
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _CharacterCounter = _interopRequireDefault(require("../InputField/_CharacterCounter"));
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _isPropIncluded = _interopRequireDefault(require("../utils/isPropIncluded"));
var _isFunction = _interopRequireDefault(require("../utils/isFunction"));
var _StyleConfig = require("../utils/StyleConfig");
var _TextAreaConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-concur_android.css") : void 0);
var _TextAreaConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-concur_default.css") : void 0);
var _TextAreaConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-concur_gateway.css") : void 0);
var _TextAreaConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-concur_ios.css") : void 0);
var _TextAreaSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-sap_fiori_3_dark.css") : void 0);
var _TextAreaSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-sap_fiori_3_hcb.css") : void 0);
var _TextAreaSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-sap_fiori_3_hcw.css") : void 0);
var _TextAreaSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-sap_fiori_3.css") : void 0);
var _TextAreaSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-sap_horizon_dark.css") : void 0);
var _TextAreaSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-sap_horizon_hcb.css") : void 0);
var _TextAreaSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-sap_horizon_hcw.css") : void 0);
var _TextAreaSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./TextArea-sap_horizon.css") : void 0);
var _excluded = ["allowEntryOverCharacterLimit", "characterLimit", "classNameMap", "controlProps", "decorators", "disabled", "inputProps", "inputRef", "inputDescribedby", "isResizableY", "label", "localizedText", "placeholder", "onBlur", "onChange", "onFocus", "onCharacterLimitStateChange", "readOnly", "required", "size", "tooltipProps", "value"],
  _excluded2 = ["inputClassName", "theme", "isFocused"];
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _TextAreaConcur_android.default,
  concur_default: _TextAreaConcur_default.default,
  concur_gateway: _TextAreaConcur_gateway.default,
  concur_ios: _TextAreaConcur_ios.default,
  sap_fiori_3_dark: _TextAreaSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _TextAreaSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _TextAreaSap_fiori_3_hcw.default,
  sap_fiori_3: _TextAreaSap_fiori_.default,
  sap_horizon_dark: _TextAreaSap_horizon_dark.default,
  sap_horizon_hcb: _TextAreaSap_horizon_hcb.default,
  sap_horizon_hcw: _TextAreaSap_horizon_hcw.default,
  sap_horizon: _TextAreaSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-textarea';

/** **TextArea** form controls are used to gather potentially lengthy input from a user. */

var TextArea = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context2, _context3;
  var addChildPropsFromContextAbove = (0, _react.useContext)(_AddChildPropsContext.default);
  var props = addChildPropsFromContextAbove ? _objectSpread(_objectSpread({}, _props), addChildPropsFromContextAbove(TextArea, _props)) : _props;
  var allowEntryOverCharacterLimit = props.allowEntryOverCharacterLimit,
    characterLimit = props.characterLimit,
    classNameMap = props.classNameMap,
    controlProps = props.controlProps,
    decorators = props.decorators,
    disabled = props.disabled,
    inputProps = props.inputProps,
    inputRef = props.inputRef,
    inputDescribedby = props.inputDescribedby,
    isResizableY = props.isResizableY,
    label = props.label,
    localizedText = props.localizedText,
    placeholder = props.placeholder,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onCharacterLimitStateChange = props.onCharacterLimitStateChange,
    readOnly = props.readOnly,
    required = props.required,
    size = props.size,
    tooltipProps = props.tooltipProps,
    value = props.value,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    limitExceeded = _useState2[0],
    setLimitExceeded = _useState2[1];
  var _useState3 = (0, _react.useState)(value),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    inputText = _useState4[0],
    setInputText = _useState4[1];
  var textareaRef = (0, _react.useRef)(null);
  var inputId = (0, _useUniqueId.default)();
  if (inputProps !== null && inputProps !== void 0 && inputProps.id) {
    inputId = inputProps.id;
  }
  var charCountDecoratorId = (0, _useUniqueId.default)();
  var handleTextSizeLimit = function handleTextSizeLimit(text) {
    var inputValueLength = (text === null || text === void 0 ? void 0 : text.length) || 0;
    var validatedText = text;
    if (inputValueLength > characterLimit) {
      if (!allowEntryOverCharacterLimit) {
        validatedText = (0, _slice.default)(text).call(text, 0, characterLimit);
        setLimitExceeded(false);
      } else {
        setLimitExceeded(true);
      }
    } else {
      setLimitExceeded(false);
    }
    return validatedText;
  };
  (0, _react.useEffect)(function () {
    setInputText(handleTextSizeLimit(value));
  }, [value]);
  (0, _react.useEffect)(function () {
    if ((0, _isFunction.default)(onCharacterLimitStateChange)) {
      onCharacterLimitStateChange(limitExceeded);
    }
  }, [limitExceeded]);
  var handleOnBlur = function handleOnBlur(e) {
    if ((0, _isFunction.default)(onBlur)) {
      onBlur(e);
    }
  };
  var handleOnFocus = function handleOnFocus(e) {
    if ((0, _isFunction.default)(onFocus)) {
      onFocus(e);
    }
  };
  var handleOnChange = function handleOnChange(event) {
    var _event$target, _event$target2;
    var inputValueLength = (event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 || (_event$target = _event$target.value) === null || _event$target === void 0 ? void 0 : _event$target.length) || 0;
    if (!characterLimit || allowEntryOverCharacterLimit || inputValueLength <= characterLimit
    // this last condition is to handle pasting text
    // and just letting the useEffect above handling
    // truncating the string
    || (event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.selectionStart) > characterLimit) {
      var _event$target3;
      setInputText(handleTextSizeLimit(event === null || event === void 0 || (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.value));
      if ((0, _isFunction.default)(onChange)) {
        onChange(event);
      }
    }
  };
  var classnames = _bind.default.bind(classNameMap);
  var controlClasses = classnames(_StyleConfig.CSS_PREFIX, "".concat(CSS_BLOCK, "__control"), controlProps === null || controlProps === void 0 ? void 0 : controlProps.className);
  var getHeadingEndDecorators = function getHeadingEndDecorators() {
    var _context;
    if (!characterLimit) {
      return decorators === null || decorators === void 0 ? void 0 : decorators.headingEnd;
    }
    return (0, _concat.default)(_context = [/*#__PURE__*/_react.default.createElement(_CharacterCounter.default, (0, _extends2.default)({}, tooltipProps, {
      id: charCountDecoratorId,
      localizedText: localizedText,
      characterLimit: characterLimit,
      currentInputLength: inputText === null || inputText === void 0 ? void 0 : inputText.length
    }))]).call(_context, (0, _toConsumableArray2.default)(_react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.headingEnd)));
  };
  var renderTextArea = function renderTextArea(_ref) {
    var _classnames;
    var inputClassName = _ref.inputClassName,
      theme = _ref.theme,
      isFocused = _ref.isFocused,
      attributes = (0, _objectWithoutProperties2.default)(_ref, _excluded2);
    var isiOS = theme.indexOf('_ios') >= 0;
    var inputClasses = classnames(_StyleConfig.CSS_PREFIX, inputClassName, "".concat(CSS_BLOCK, "__input"), inputProps === null || inputProps === void 0 ? void 0 : inputProps.className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "__input--resize-none"), !isResizableY || disabled), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "__input--md"), size === 'md'), _classnames));
    var getPlaceholderText = function getPlaceholderText() {
      if (isiOS && !disabled) {
        return (0, _reactToString.default)(label);
      }
      if (placeholder && !readOnly && !disabled) {
        return placeholder;
      }
      return undefined;
    };
    return /*#__PURE__*/_react.default.createElement("textarea", (0, _extends2.default)({}, inputProps, attributes, {
      "aria-required": required,
      className: inputClasses,
      disabled: disabled,
      id: inputId,
      placeholder: getPlaceholderText(),
      readOnly: readOnly,
      ref: (0, _reactMergeRefs.default)([inputRef, textareaRef]),
      value: inputText,
      onBlur: handleOnBlur,
      onChange: handleOnChange,
      onFocus: handleOnFocus
    }));
  };
  var describedbyString;
  if (typeof inputDescribedby === 'string') {
    describedbyString = inputDescribedby;
  } else if (Array.isArray(inputDescribedby)) {
    var _inputDescribedby$joi;
    describedbyString = (_inputDescribedby$joi = inputDescribedby.join) === null || _inputDescribedby$joi === void 0 ? void 0 : _inputDescribedby$joi.call(inputDescribedby, ' ');
  }
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.default.Provider, {
    value: null
  }, /*#__PURE__*/_react.default.createElement(_FormField.default, (0, _extends2.default)({}, otherProps, {
    inputDescribedby: characterLimit ? (0, _trim.default)(_context2 = (0, _concat.default)(_context3 = "".concat(describedbyString || '', " ")).call(_context3, charCountDecoratorId)).call(_context2) : describedbyString,
    controlProps: _objectSpread(_objectSpread({}, controlProps), {}, {
      className: controlClasses
    }),
    decorators: _objectSpread(_objectSpread({}, decorators), {}, {
      headingEnd: getHeadingEndDecorators()
    }),
    disabled: disabled,
    inputId: inputId,
    label: label,
    readOnly: readOnly,
    renderInput: renderTextArea,
    ref: ref,
    required: required,
    size: size
  })));
});
TextArea.displayName = 'TextArea';
TextArea.propTypes = _objectSpread(_objectSpread({}, _FormField.default.propTypes), {}, {
  /** @ignore, prop is only for FormField */
  inputId: _CustomPropTypes.default.notDefined,
  /** @ignore, prop is only for FormField */
  renderInput: _CustomPropTypes.default.notDefined,
  /** Set to true to continue allowing additional characters past the `characterLimit`.
   * This character counter will show the user when they have exceeded the limit.
   */
  allowEntryOverCharacterLimit: _propTypes.default.bool,
  /** Maximum characters allowed within **TextArea** */
  characterLimit: _propTypes.default.number,
  /** Additional props to spread to the `<textarea>` element. */
  inputProps: _propTypes.default.object,
  /** Attach a ref to the `<textarea>` element. */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Sets if the **TextArea** can be resized by the user vertically */
  isResizableY: _propTypes.default.bool,
  /** Localized text to be updated based on location/language when `characterLimit`
   * prop is defined:
   *
   * `counterTooltipMessage`: Localized string to display in the character
   * counter tooltip. Available as `CoreUIComponents.counterTooltipMessage`.
   *
   * `exceededCountWarning`: Localized string to display in the tooltip when
   * the character limit has been exceeded. Available as `CoreUIComponents.exceededCountWarning`.
   */
  localizedText: _CustomPropTypes.default.conditionallyRequired(_propTypes.default.shape({
    counterTooltipMessage: _CustomPropTypes.default.localizedString('CoreUIComponents.counterTooltipMessage'),
    exceededCountWarning: _CustomPropTypes.default.localizedString('CoreUIComponents.exceededCountWarning')
  }), function (props) {
    return (0, _isPropIncluded.default)(props, 'characterLimit');
  }, '`characterLimit` is provided'),
  /** Placeholder displayed when field is empty. */
  placeholder: _propTypes.default.string,
  /** Additional props to be passed into the `Tooltip` element. */
  tooltipProps: _propTypes.default.object,
  /** The value of the field. */
  value: _propTypes.default.string,
  /** Callback function for the blur event on the textarea.
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   */
  onBlur: _propTypes.default.func,
  /** Callback function for the change event on the textarea.
     * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
     */
  onChange: _propTypes.default.func,
  /** Callback function when the character limit state changes.  This only applies
   * when `allowEntryOverCharacterLimit` is true.
   * @param {bool} limitExceeded - Whether the current value has exceeded the character limit
  */
  onCharacterLimitStateChange: _propTypes.default.func,
  /** Callback function for the focus event on the textarea.
     * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
     */
  onFocus: _propTypes.default.func
});
TextArea.defaultProps = {
  isResizableY: true
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(TextArea);
exports.default = _default;